import React from 'react';
import './index.scss';

const NoMoreBottom = () => {
  return <div className="no-more-bottom">已经到底了</div>;
};

export default NoMoreBottom;
